import { UserService } from './user.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, tap } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private _isLoggedIn$ = new BehaviorSubject<boolean>(false);
  isLoggedin$ = this._isLoggedIn$.asObservable();

  private _userRole$ = new BehaviorSubject<string>('');
  userRole$ = this._userRole$.asObservable();

  constructor(private api: UserService, private router: Router) {
    const token = localStorage.getItem('accesstoken'); // Load the value of the token to a variable
    this._isLoggedIn$.next(!!token); // Convert to boolean value
  }

  login(data: any) {
    return this.api.login(data.email, data.password).pipe(
      tap((response: any) => {
        if (response.flag === 1) {
          localStorage.removeItem('accesstoken');
          localStorage.removeItem('refreshtoken');
          localStorage.removeItem('role');
          localStorage.setItem('idnumber', response.id);
          localStorage.setItem('accesstoken', response.accessToken);
          localStorage.setItem('refreshtoken', response.refreshToken);
          localStorage.setItem('role', response.role);
          //  this.navi.startWatch();
          this.router.navigate(['main/dashboard']);
        }
      })
    );
  }
}
